module.exports = __webpack_public_path__ + "static/media/OpenSans-LightItalic.c147d130.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/OpenSans/OpenSans-LightItalic.ttf
// module id = 311
// module chunks = 0